export enum TypeLayoutRemessaRetornoEnum {
    BOLETO = "Boleto",
    DEBITO_AUTOMATICO = "Débito Automático",
}